// extracted by mini-css-extract-plugin
module.exports =  {"root":"L7u2urug3NE7S9JjVYWm","chipFix":"DirMBs1tuGvDOUlxGLPv","bigNumber":"tHjYpLH8Aiq3jomGJdP6"};